const GENERIC_TITLE = /^(game\s*play|gameplay(\s+clip)?|game\s*bite|short|shorts|video|clip)$/i;

function asText(value, depth = 0) {
  if (depth > 3 || value == null) return "";
  if (typeof value === "string") return value.trim();
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  if (typeof value === "object") {
    return asText(
      value.title ||
        value.name ||
        value.text ||
        value.label ||
        value.en ||
        value.ur ||
        value.caption,
      depth + 1,
    );
  }
  return "";
}

function cleanTitle(raw) {
  const source = raw.replace(/\.[a-z0-9]{2,5}$/i, " ");
  const withoutUuid = source.replace(
    /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi,
    " ",
  );
  const words = withoutUuid
    .replace(/[-_]+/g, " ")
    .split(/\s+/)
    .map((word) => {
      if (/\d/.test(word) && /^[0-9a-f]+$/i.test(word)) return "";
      if (/^[0-9a-f]{8,}$/i.test(word)) return "";
      return word.replace(/^[0-9a-f]*\d[0-9a-f]{4,}(?=[A-Za-z]{2,})/i, "");
    })
    .filter((word) => {
      if (!word) return false;
      if (/^[0-9a-f]{8,}$/i.test(word)) return false;
      if (/\d/.test(word) && /^[0-9a-f]+$/i.test(word)) return false;
      return true;
    });
  const title = words.join(" ").replace(/\s+/g, " ").trim();
  if (!title || GENERIC_TITLE.test(title)) return "";
  const lookedLikeFile = /[-_]/.test(raw) || /[0-9a-f]{8}/i.test(raw);
  if (!lookedLikeFile) return title;
  return title.replace(/\b\w/g, (char) => char.toUpperCase());
}

function titleFromMedia(short) {
  const urls = [
    short?.video,
    short?.video_url,
    short?.videoUrl,
    short?.thumbnail,
    short?.thumbnail_url,
    short?.image,
  ];
  for (const url of urls) {
    const title = cleanTitle(asText(url).split("/").pop() || "");
    if (title) return title;
  }
  return "";
}

export function shortTitle(short) {
  if (!short || typeof short !== "object") return "Gameplay clip";
  const texts = [
    short.title,
    short.name,
    short.caption,
    short.heading,
    short.video_title,
    short.videoTitle,
    short.short_title,
    short.shortTitle,
    short.description,
    short.short_description,
    short.subtitle,
    short.content_title,
    short.label,
    short.text,
  ]
    .map((value) => asText(value))
    .filter(Boolean);
  const specific = texts.map((text) => cleanTitle(text)).find(Boolean);
  if (specific) return specific;
  return titleFromMedia(short) || "Gameplay clip";
}
